import { render, staticRenderFns } from "./reportParamsTab.vue?vue&type=template&id=2825d6b9"
import script from "./reportParamsTab.vue?vue&type=script&lang=js"
export * from "./reportParamsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports